import React from 'react';
import { AlertCircle, Lock, Smartphone, FileX } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 md:py-24 px-4 bg-cream-dark border-y border-gold/20" data-id="element-181">
      <div className="max-w-4xl mx-auto" data-id="element-182">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-183">
          El problema de nuestro mundo moderno
        </h2>

        <div className="bg-white p-8 md:p-12 rounded-sm shadow-warm border-t-4 border-burgundy" data-id="element-184">
          <p className="text-xl mb-8 leading-relaxed" data-id="element-185">
            Hoy en día, el banco, el seguro y hasta los álbumes de fotos
            familiares están protegidos por códigos, huellas digitales y
            contraseñas que cambian cada mes.
          </p>

          <p className="text-xl mb-10 leading-relaxed font-semibold text-burgundy" data-id="element-186">
            Si algo llegara a sucederle, sus hijos no solo enfrentarían el dolor
            de su ausencia; enfrentarían meses de peleas con bancos, técnicos de
            computadoras y abogados solo para recuperar lo que legalmente les
            pertenece.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12" data-id="element-187">
            <div className="flex items-start gap-4" data-id="element-188">
              <div className="bg-cream p-3 rounded-full shrink-0" data-id="element-189">
                <Lock className="w-6 h-6 text-burgundy" data-id="element-190" />
              </div>
              <p className="text-lg" data-id="element-191">
                Cuentas bancarias congeladas por falta de acceso digital.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-192">
              <div className="bg-cream p-3 rounded-full shrink-0" data-id="element-193">
                <Smartphone className="w-6 h-6 text-burgundy" data-id="element-194" />
              </div>
              <p className="text-lg" data-id="element-195">
                Sin el acceso a su teléfono celular, ni siquiera podrán avisar a
                sus seres queridos en el extranjero.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-196">
              <div className="bg-cream p-3 rounded-full shrink-0" data-id="element-197">
                <FileX className="w-6 h-6 text-burgundy" data-id="element-198" />
              </div>
              <p className="text-lg" data-id="element-199">
                Pérdida total de fotos familiares y recuerdos almacenados
                únicamente "en la nube".
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-200">
              <div className="bg-cream p-3 rounded-full shrink-0" data-id="element-201">
                <AlertCircle className="w-6 h-6 text-burgundy" data-id="element-202" />
              </div>
              <p className="text-lg" data-id="element-203">
                Trámites legales costosos y prolongados que podrían haberse
                evitado con una simple hoja de papel.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}